import { request } from '../request';

export function fetchGetCategoryList(data?: Api.Category.CategoryParams) {
  return request<Api.Category.CategoryList>({
    url: '/developer-platform/api/category/detail/page',
    method: 'POST',
    data,
  });
}


export function fetchGetBelongClassList() {
  return request({
    url: '/developer-platform/api/category/detail/listClass',
    method: 'GET',
  });
}



export function fetchChangeEnableStatus(data: string) {
  return request<number>({
    url: '/developer-platform/api/category/update/changeEnableStatus',
    method: 'POST',
    data
  });
}


export function fetchAddBaseInfo(data: object) {
  return request<string>({
    url: '/developer-platform/api/category/add/baseInfo',
    method: 'POST',
    data,
    headers: {
      "Content-Type": 'multipart/form-data'
    }
  });
}


export function fetchAddFunctionGroup(data: object) {
  return request<number>({
    url: '/developer-platform/api/category/function/add/functionGroup',
    method: 'POST',
    data
  });
}


export function fetchGetCategoryFunctions(params?: Api.Category.searchConfigModel) {
  return request({
    url: '/developer-platform/api/category/function/detail/functions',
    method: 'GET',
    params,
    headers: {
      "Content-Type": 'application/x-www-form-urlencoded'
    }
  });
}


export function fetchQueryCategoryList(params?: Api.Category.SearchCategory) {
  return request({
    url: '/developer-platform/api/category/function/detail/queryCategoryList',
    method: 'GET',
    params,
    headers: {
      "Content-Type": 'application/x-www-form-urlencoded'
    }
  });
}



export function fetchAddPullFunctions(data?: string) {
  return request({
    url: '/developer-platform/api/category/function/add/pullFunctionsWithRelate',
    method: 'POST',
    data
  });
}


export function fetchUpdateRelateFunctions(data: any) {
  return request({
    url: '/developer-platform/api/category/function/update/relateFunctions',
    method: 'POST',
    data
  });
}

export function fetchChangeRequired(data: any) {
  return request({
    url: '/developer-platform/api/category/function/update/changeRequired',
    method: 'POST',
    data
  });
}


export function fetchAddFunction(data: any) {
  return request({
    url: '/developer-platform/api/category/function/add/function',
    method: 'POST',
    data
  });
}



export function fetchGetDetailFunction(data: any) {
  return request({
    url: '/developer-platform/api/category/function/detail/function',
    method: 'POST',
    data,
    headers: {
      "Content-Type": 'application/x-www-form-urlencoded'
    }
  });
}


export function fetchUpdateFunction(data: any) {
  return request({
    url: '/developer-platform/api/category/function/update/function',
    method: 'POST',
    data
  });
}


export function fetchDeleteFunction(data: any) {
  return request({
    url: '/developer-platform/api/category/function/delete/function',
    method: 'POST',
    data,
  });
}



export function fetchEditFunctionGroup(data: object) {
  return request<number>({
    url: '/developer-platform/api/category/function/update/functionGroup',
    method: 'POST',
    data
  });
}

export function fetchDeleteGroup(data: any) {
  return request({
    url: '/developer-platform/api/category/function/delete/functionGroup',
    method: 'POST',
    data,
  });
}


export function fetchGetCategoryFullInfo(params?: Api.Category.SearchCategory) {
  return request({
    url: '/developer-platform/api/category/detail/fullInfo',
    method: 'GET',
    params,

  });
}

export function fetchGetVisionList(params?: Api.Category.categoryBase) {
  return request({
    url: '/developer-platform/api/category/detail/listVersion',
    method: 'GET',
    params,
  });
}


export function fetchUpdateBaseForm(data: any) {
  return request({
    url: '/developer-platform/api/category/update/baseInfo',
    method: 'POST',
    data,
    headers: {
      "Content-Type": 'multipart/form-data'
    }
  });
}


export function fetchListCategory(data: any) {
  return request({
    url: '/developer-platform/api/category/update/release',
    method: 'POST',
    data,
  });
}

export function fetchUnListCategory(data: any) {
  return request({
    url: '/developer-platform/api/category/update/remove',
    method: 'POST',
    data,
  });
}

export function fetchDeleteCategory(data: any) {
  return request({
    url: '/developer-platform/api/category/delete/batch',
    method: 'POST',
    data,
  });
}


export function fetchListCategoryList() {
  return request({
    url: '/developer-platform/api/product/detail/listCategory',
    method: 'POST',
  });
}
